import { useEffect, useState } from "react";
import { EJccFormTypes } from "../../interface/IPayment";
import { IPayer } from "../interface/IManageCards";
import { PAYER_ROUTE, removePaymentCardRoute, SAVE_NEW_CARD_ROUTE, updateDefaultPaymentMethodRoute } from "@api-routes";
import { getResponseToState, IPayerResponse } from "../mappers/getPayerDetailsMapper";
import { useFetch } from "@common/hook/useFetch";
import { IError } from "src/itsf/fetch/fetcherUtils";

export const usePaymentCardList = (setOpenedIframe: (openedIframe?: EJccFormTypes) => void) => {
    const [cardState, { get, deleteCall, put, post }] = useFetch();

    const [payerDetails, setPayerDetails] = useState<IPayer>();
    const [cardError, setCardError] = useState<IError>();

    const getPayerDetails = () => {
        setPayerDetails(undefined);
        setOpenedIframe();

        get<IPayerResponse>(PAYER_ROUTE, {
            forwardError: true,
            headers: {
                "Cache-Control": "no-cache",
            },
        })
            .then((payerResponse) => {
                if (payerResponse) {
                    setPayerDetails(getResponseToState(payerResponse));
                }
            })
            .catch(setCardError);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(getPayerDetails, []);

    const removeCard = (cardId: number) => {
        deleteCall<boolean>(removePaymentCardRoute(cardId), {
            forwardError: true,
        })
            .then((result) => {
                if (result) {
                    getPayerDetails();
                }
            })
            .catch(setCardError);
    };

    const setDefaultCard = (cardId: number) => {
        put<boolean>(updateDefaultPaymentMethodRoute(cardId), { forwardError: true })
            .then((result) => {
                if (result) {
                    getPayerDetails();
                }
            })
            .catch(setCardError);
    };

    const retryCard = () => {
        setCardError(undefined);
        getPayerDetails();
    };

    const saveNewCard = (orderId: string, finaliseAddCardCallback: (result: boolean) => void) => {
        post<boolean>(SAVE_NEW_CARD_ROUTE, {
            body: {
                orderId: orderId,
            },
        })
            .then((response) => {
                finaliseAddCardCallback(response || false);
                if (response) {
                    getPayerDetails();
                }
            })
            .catch(setCardError);
    };

    return {
        cardError,
        cardIsLoading: cardState.isLoading,
        getPayerDetails,
        payerDetails,
        removeCard,
        retryCard,
        setDefaultCard,
        saveNewCard,
    };
};
